import { LocationStrategy } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MuiScrollbarService } from '@move/ui';
import { default as Parallax } from 'parallax-js';


@Component({
  selector: 'mmu-move-parallax-bg',
  templateUrl: './mmu-move-parallax-bg.component.svg',
  styleUrls: ['./mmu-move-parallax-bg.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MmuMoveParallaxBgComponent implements AfterViewInit, OnDestroy {
  @Input()
  set parallaxEnabled(val: boolean) {
    this._parallaxEnabled = val;
    this.setParallaxEnabled(val);
  }

  get parallaxEnabled(): boolean {
    return this._parallaxEnabled;
  }

  @Input() imgDir: string;

  @HostBinding('class.mmu-move-parallax-bg') readonly _baseClass = true;

  readonly selectorClass = 'layer';
  parallax: Parallax | null = null;

  private _parallaxEnabled = true;

  constructor(
    private _locationStrategy: LocationStrategy,
    private _el: ElementRef,
    private route: ActivatedRoute,
    private scrollService: MuiScrollbarService
  ) {
    this.imgDir = this._locationStrategy.getBaseHref() + 'assets/img/bg/';
  }

  ngAfterViewInit(): void {
    const scrollToElement: string | null = this.route.snapshot.queryParamMap.get('scroll');
    if (scrollToElement) {
      this.scrollService.scrollToElement(scrollToElement);
    }

    /* Since parallax-js lives outside the Angular lifecycle, the Angular testability in e2e tests will never become stable when
     * this remains active. Therefore, the Parallax effect should be disabled in e2e tests. */
    if (!navigator.webdriver) {
      this.parallax = new Parallax(this._el.nativeElement, {
        selector: '.' + this.selectorClass
      });

      this.setParallaxEnabled(this._parallaxEnabled);
    }
  }

  ngOnDestroy(): void {
    if (this.parallax) {
      this.parallax.destroy();
    }
  }

  protected setParallaxEnabled(val: boolean): void {
    if (val && this.parallax) {
      this.parallax.enable();
    } else if (!val && this.parallax) {
      this.parallax.disable();
    }
  }
}
